import * as React from "react";
import CalendarView, { type CalendarViewProps } from "./CalendarView";
import { STANDARD_HINWEIS } from "./CalendarModalKopf";
import { AppFlaechenOverlay } from "../shared/AppFlaechenOverlay";

/**
 * Der große Kalender als Vollflächen-Overlay — die Hülle, die
 * `openKalenderFenster` (Fenster im WindowManager) ablöst.
 *
 * Warum kein Fenster mehr: der Kalender ist beim Verknüpfen die BÜHNE, nicht
 * ein Dialog unter vielen. Als Fenster war er ein Geschwister der Dialoge, die
 * er selbst öffnet („+ Neuer Termin", Kontakt wählen, Bestätigungen) — ein
 * Klick in den Kalender holte ihn nach vorn und begrub den kleinen Dialog
 * dahinter, ohne Dock-Eintrag und damit unerreichbar. Als Overlay liegt er
 * fest UNTER allem, was aus ihm heraus aufgeht (siehe die z-index-Leiter in
 * `shared/AppFlaechenOverlay.tsx`).
 *
 * Der Inhalt ist unverändert derselbe `CalendarView` wie im Fenster; nur die
 * Hülle wechselt. Titel, Hinweis, „Fertig" und das Schließkreuz stellt die
 * Hülle — deshalb bleibt die eigene Kopfzeile des Auswahlmodus
 * (`CalendarModalKopf`) hier weg (`imOverlay`).
 */
export type KalenderOverlayProps = Omit<
    CalendarViewProps,
    "windowId" | "deepLink" | "imOverlay"
> & {
    /** Kreuz, „Fertig" und ESC rufen alle dasselbe. */
    onSchliessen: () => void;
};

export const KalenderOverlay: React.FC<KalenderOverlayProps> = ({ onSchliessen, ...params }) => {
    const auswahl = !!params.onPick;

    return (
        <AppFlaechenOverlay
            titel={params.titel ?? (auswahl ? "Termin verknüpfen" : "Kalender")}
            hinweis={params.hinweis ?? (auswahl ? STANDARD_HINWEIS : undefined)}
            onSchliessen={onSchliessen}
        >
            <CalendarView
                {...params}
                modus={auswahl ? "auswahl" : "seite"}
                // Im Overlay niemals Deep-Link-Parameter der aktuellen Route lesen.
                deepLink={false}
                // Die Kalenderauswahl im Overlay ist lokal — sie verändert die
                // persistierte Auswahl auf /termine nicht.
                auswahlIsoliert={params.auswahlIsoliert ?? true}
                imOverlay
            />
        </AppFlaechenOverlay>
    );
};

export default KalenderOverlay;
